import React from 'react';
const SuccessCheckIcon = () => (React.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("circle", { cx: "20", cy: "20", r: "13.333", fill: "#EBFFF7", stroke: "#0D9468", "stroke-width": "1.4" }),
    React.createElement("path", { d: "M13.334 19.9998L18.0007 24.6665L26.6673 14.6665", stroke: "#0D9468", "stroke-width": "2.8", "stroke-linecap": "round", "stroke-linejoin": "round" })));
export default SuccessCheckIcon;
